import { createAPI } from '../../composable/useAPI';

/**
 * useProductionDailyAPI — 제품 단위 일일 생산 실적 입력·수정·조회 hook (방안 A).
 *
 * BE: `POST/PUT/GET /api/v2/production/daily` (docs/modules/backend/production/production-daily.md).
 * 통계 hook(useProductionStatAPI) 과 분리 — 통계는 집계 조회, 본 hook 은 단건 CRUD/drill-down.
 *
 * 각 메서드는 `{ ok, status, data, message }` 형태를 반환하여 호출 측(모달)이
 * 400(불량>생산)/403(테넌트)/404(대상 없음) 를 구분해 사용자 메시지를 띄울 수 있게 한다.
 */
const STATUS_MESSAGE = {
  400: '입력 값이 올바르지 않습니다. (불량수량은 생산수량을 넘을 수 없습니다)',
  403: '해당 회사의 데이터를 변경할 권한이 없습니다.',
  404: '수정할 생산 실적을 찾을 수 없습니다.',
};

const messageFor = (status) =>
  STATUS_MESSAGE[status] || '요청 처리 중 오류가 발생했습니다.';

export const useProductionDailyAPI = () => {
  const api = createAPI();

  const request = {
    // 일자별 제품 분해 조회 (drill-down). 실패 시 data: []
    getDaily: async (params) => {
      try {
        const res = await api.get('/api/v2/production/daily', { params });
        return { ok: true, status: res.data?.status ?? 200, data: res.data?.data ?? [] };
      } catch (err) {
        const status = err.response?.status;
        return { ok: false, status, data: [], message: messageFor(status) };
      }
    },

    // 등록 (멱등 upsert)
    createDaily: async (data) => {
      try {
        const res = await api.post('/api/v2/production/daily', data);
        return { ok: true, status: res.data?.status ?? 200, data: res.data?.data ?? null };
      } catch (err) {
        const status = err.response?.status;
        return { ok: false, status, data: null, message: messageFor(status) };
      }
    },

    // 수정 (자연키 조회, 없으면 404)
    updateDaily: async (data) => {
      try {
        const res = await api.put('/api/v2/production/daily', data);
        return { ok: true, status: res.data?.status ?? 200, data: res.data?.data ?? null };
      } catch (err) {
        const status = err.response?.status;
        return { ok: false, status, data: null, message: messageFor(status) };
      }
    },
  };

  return { ...request };
};
